import React from "react";
import SubmenuChevron from "./SubmenuChevron";

interface MenuItemArrowProps {
  isActive: boolean;
}

// Trailing chevron on the root mobile menu rows. Hidden from lg up by the
// `.menu-box > span` rule in globals.css, where the nav becomes horizontal.
const MenuItemArrow: React.FC<MenuItemArrowProps> = ({ isActive }) => {
  return (
    <span className="absolute right-0 top-0 flex justify-center items-center h-full w-[32px] text-[var(--color-primary-text)]">
      <SubmenuChevron isOpen={isActive} />
    </span>
  );
};

export default MenuItemArrow;
